import { render } from "./LoginButton.vue?vue&type=template&id=c8cda4e0&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"

import "./LoginButton.vue?vue&type=style&index=0&id=c8cda4e0&scoped=true&lang=css"

import exportComponent from "/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cda4e0"]])

export default __exports__